import { Observable, Subscription } from 'rxjs';
import { ActionCreatorAbstract } from '@ispm/core/classes/action-creator.abstract';
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';

export abstract class DataHandlerHelperServices extends ActionCreatorAbstract  {
  protected threads = [];
  protected requests: Map<string, any> = new Map();
  protected displayColumns: Map<string, any> = new Map<string, any>();

  protected constructor(store: Store<IgenomicsState>) {
    super(store);
  }

  /**
   *
   * @param keys
   * @return {string}
   */
  protected buildCacheKey(...keys) {
    return keys.join('-');
  }

  protected cancelPreviousRequests(cacheKeyPattern: RegExp = null) {
    this.requests.forEach((request, key) => {
      if (cacheKeyPattern && !cacheKeyPattern.test(key)) {
        return;
      }

      request.subscriber.unsubscribe();
      this.requests.delete(key);
    });
  }

  protected getOngoingRequestExisted(key: string): {
    request: Observable<any>,
    subscriber: Subscription,
    query: string
  } {
    return this.requests.get(key);
  }

  protected cacheOngoingRequest(key: string, request: Observable<any>, subscriber: Subscription, query?: string) {
    const cacheObject = { request, subscriber, query};
    this.requests.set(key, cacheObject);

    return cacheObject;
  }
}
